module.exports = __webpack_public_path__ + "img/medio_1.b51156ed.png";